/**
 * The five states of a webinar, as the member app labels and colours them.
 *
 * The state itself is derived on the server (`services/event_state.py`) and arrives
 * on every event payload; this module only says what to call each one and whether
 * it is worth a badge. "Připravujeme" is the resting state of most of the calendar
 * and gets no badge — a badge on every card is no badge at all.
 */

import type { EventState } from "~/types/event";

export const EVENT_STATE_LABEL_KEYS: Record<EventState, string> = {
  upcoming: "events.state.upcoming",
  soon: "events.state.soon",
  live: "events.state.live",
  ended: "events.state.ended",
  recording: "events.state.recording",
};

/** States that change what a card means and therefore earn a badge. */
export const BADGED_STATES: ReadonlySet<EventState> = new Set([
  "soon",
  "live",
  "ended",
  "recording",
]);

/** Whether the broadcast can be joined right now. */
export function isJoinable(state: EventState): boolean {
  return state === "live";
}

/** Whether a place can still be booked, as far as the state alone can tell. */
export function isStateOpen(state: EventState): boolean {
  return state === "upcoming" || state === "soon" || state === "live";
}
